module.exports = __webpack_public_path__ + "files/c0d06235d764b844e0ef9ef6b670f130.svg";